import React, { useContext } from "react";
import { ShopContext } from "../context/ShopContext";
import ScrollToTop from "../components/util/ScrollToTop";
import Seo from "../components/seo/Seo";

const Gallery = () => {
    const { all_product } = useContext(ShopContext);
    const cakePhotos = all_product
        .filter((item) => item.category === "cake" && item.gallery)
        .flatMap((item) => item.images.map((image, i) => ({
            key: `${item.id}-${i}`,
            image,
            caption: item.name,
        })));

    return (
        <>
            <Seo
                title="Cake Gallery"
                description="Browse photos of custom cakes made by Inioli in East Brunswick, NJ - chocolate, fusion, step cakes, and themed designs."
                path="/gallery"
            />
            <ScrollToTop />
            <div className="flex flex-col items-center py-8 px-4">
                <h1 className="text-3xl font-bold mb-6">Gallery</h1>
                <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-screen-xl">
                    {cakePhotos.map(({ key, image, caption }) => (
                        <div key={key} className="flex flex-col">
                            <img src={image} alt={caption} className="rounded-lg object-cover w-full h-64" />
                            <p className="mt-2 text-center text-gray-700">{caption}</p>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
};

export default Gallery;
